// Which sim seat does this client play?
//
// The match-server owns the seat table (apps/match-server/src/seats.ts):
// humans take seats 0..H-1 in provisioning order — the order of `players` in
// match:found — and AIs follow. A client NEVER decides its own index for the
// sim; it reads it here, and the server stamps `playerIndex` on every intent
// regardless of what the client sends.

import type { MatchInfo } from './types.js';

/** The seat the server's `match:starting.seats` table gives `playerId`, if sent. */
export function seatFromTable(
  seats: Readonly<Record<string, number>> | undefined,
  playerId: string,
): number | undefined {
  const s = seats?.[playerId];
  return typeof s === 'number' && Number.isInteger(s) && s >= 0 ? s : undefined;
}

/** Provisional seat from list order (identical to the server's table by contract). */
export function localSeatOf(matchInfo: Pick<MatchInfo, 'players' | 'localPlayerId'>): number {
  const i = matchInfo.players.findIndex((p) => p.accountId === matchInfo.localPlayerId);
  return i >= 0 ? i : 0;
}
